const CANDIDATE = "candidate";
const ELECTED_OFFICIAL = "electedOfficial";

export default {
  CANDIDATE,
  ELECTED_OFFICIAL
};
